<script setup lang="ts">
/** In place of the composer for an inbox comment thread: comments are answered on the comment screen. */
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { getCommentsApi } from '../../api/comments'
import Icon from '../ui/Icon.vue'

const props = defineProps<{ convId: string }>()
const router = useRouter()
const busy = ref(false)
const error = ref<string | null>(null)

async function open(): Promise<void> {
  busy.value = true
  error.value = null
  try {
    const id = await getCommentsApi().ofConversation(props.convId)
    void router.push({ name: 'comments', query: id ? { c: id } : {} })
  } catch (e) {
    error.value = e instanceof Error ? e.message : String(e)
  } finally {
    busy.value = false
  }
}
</script>

<template>
  <div class="cbar">
    <span class="cb-ic" aria-hidden="true"><Icon name="comments" /></span>
    <span class="cb-b">
      <span class="cb-t">คอมเมนต์ใต้โพสต์หรือแอด</span>
      <span class="cb-s">{{ error ?? 'ตอบใต้คอมเมนต์ หรือส่งแชทส่วนตัว ได้ที่หน้าคอมเมนต์' }}</span>
    </span>
    <button class="cb-go" :disabled="busy" @click="open"><span>เปิดในหน้าคอมเมนต์</span><Icon name="arrowRight" /></button>
  </div>
</template>

<style scoped>
.cbar {
  flex: none;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  background: #fff;
  border-top: 1px solid var(--line);
}
.cb-ic {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: none;
  background: #eceefa;
  color: #3e48a0;
}
.cb-ic :deep(.ic) {
  width: 18px;
  height: 18px;
}
.cb-b {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}
.cb-t {
  font-size: 14px;
  font-weight: 600;
  line-height: 22px;
}
.cb-s {
  font-size: 12.5px;
  line-height: 19px;
  color: var(--mut);
}
.cb-go {
  flex: none;
  height: 40px;
  padding: 0 14px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  line-height: 22px;
  white-space: nowrap;
  background: var(--ac);
  color: #fff;
}
.cb-go:hover:not(:disabled) {
  background: var(--ac2);
}
.cb-go :deep(.ic) {
  width: 16px;
  height: 16px;
}
</style>
